import * as types from './types';

// eslint-disable-next-line import/prefer-default-export
export const setPersistedState = base => ({
  type: types.SET_PERSISTED_STATE,
  base,
});

export const filterAndApplyState = base => ({
  type: types.FILTER_AND_APPLY_STATE,
  base,
});

export const setDimension = dimension => ({
  type: types.SET_DIMENSION,
  dimension,
});

export const setMode = mode => ({
  type: types.SET_MODE,
  mode,
});

export const setTrendsMetrics = metrics => ({
  type: types.SET_TRENDS_METRICS,
  metrics,
});

export const setFiltersMetrics = metrics => ({
  type: types.SET_FILTERS_METRICS,
  metrics,
});

export const triggerPersistence = configuration => ({
  type: types.PERSIST_STATE,
  configuration,
});

export const applyTrendsSelectedNocFilters = (filters, mode) => ({
  type: types.APPLY_TRENDS_SELECTED_NOC_FILTERS,
  filters,
  mode,
});

export const applyFiltersSelectedNocFilters = (filters, mode) => ({
  type: types.APPLY_FILTERS_SELECTED_NOC_FILTERS,
  filters,
  mode,
});

export const updateSavedFiltersSelectedNocFilters = filters => ({
  type: types.UPDATE_SAVED_FILTERS_SELECTED_NOC_FILTERS,
  filters,
});

export const applyDrilldown = params => ({
  type: types.APPLY_DRILLDOWN,
  params,
});

export const updateThresholdChangeStatus = hasUnsavedChanges => ({
  type: types.SAVE_THRESHOLD_CHANGE_STATUS,
  hasUnsavedChanges,
});

export const setAllThresholdCellSelection = selection => ({
  type: types.SET_ALL_THRESHOLD_SELECTION,
  selection,
});

export const setAdminProfile = isAdmin => ({
  type: types.SET_ADMIN_PROFILE,
  isAdmin,
});

export const setTrendsSorting = sort => ({
  type: types.SET_TRENDS_SORTING,
  sort,
});

export const setFiltersSorting = sort => ({
  type: types.SET_FILTERS_SORTING,
  sort,
});

export const setAutoSortEnabled = isAutoSortEnabled => ({
  type: types.SET_AUTO_SORT,
  isAutoSortEnabled,
});

export const setIfRedirectedFromNocTile = isRedirectedFromNocTiles => ({
  type: types.SET_REDIRECTED_FROM_NOC_TILE,
  isRedirectedFromNocTiles,
});
